import { render, staticRenderFns } from "./TransactionDetailComponent.vue?vue&type=template&id=4a80491b"
import script from "./TransactionDetailComponent.vue?vue&type=script&lang=js"
export * from "./TransactionDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailComponent.vue?vue&type=style&index=0&id=4a80491b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports